(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
constructor() {
super();
this.elements = {
input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
button: this.querySelector('button'),
panel: this.querySelector('ul'),
};
this.elements.button.addEventListener('click', this.openSelector.bind(this));
this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
}

hidePanel() {
this.elements.button.setAttribute('aria-expanded', 'false');
this.elements.panel.setAttribute('hidden', true);
}

onContainerKeyUp(event) {
if (event.code.toUpperCase() !== 'ESCAPE') return;

this.hidePanel();
this.elements.button.focus();
}

onItemClick(event) {
event.preventDefault();
this.elements.input.value = event.currentTarget.dataset.value;
this.querySelector('form')?.submit();
}

openSelector() {
this.elements.button.focus();
this.elements.panel.toggleAttribute('hidden');
this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') ===
'false').toString());
}

closeSelector(event) {
const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
if (event.relatedTarget === null || shouldClose) {
this.hidePanel();
}
}
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-started-wizard-tapcart"]) return;
  try {
    
  let args = {
    "wz_nav_style": "progress", // dots, tabs, progress
    "wz_ori": "horizontal",
    "wz_buttons": ".wzd-buttons",
    "wz_button": ".wzd-button",
    "buttons": false,
    "navigation": 'all' // buttons, nav, all
  };

  const wizard = new Wizard(args);
  wizard.init();

  class TotalBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.totalBar = document.getElementById('total-bar');
      this.totalBarBounds = {};
      this.totalBarScrollTop = 0;
      this.onScrollHandlerTotalBar = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandlerTotalBar, false);
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandlerTotalBar);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.totalBarBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.totalBar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= 0) {
        requestAnimationFrame(this.hide.bind(this));
      }
      this.totalBarScrollTop = scrollTop;
    }
    hide() {
      this.totalBar.classList.add('hide');
      this.totalBar.classList.remove('animate');
    }
    reveal() {
      this.totalBar.classList.add('animate');
      this.totalBar.classList.remove('hide');
    }
  }
  customElements.define('total-bar', TotalBar);

  class FilterBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.filterBar = document.getElementById('filter-bar');
      this.filterBarBounds = {};
      this.filterBarScrollTop = 0;
      this.onScrollHandlerFilterBar = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandlerFilterBar, false);
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandlerFilterBar);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.filterBarBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.filterBar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var topFilter = document.getElementById('Wizard_TopFilterDropdown').getBoundingClientRect();
      if (scrollTop > topFilter.top + window.scrollY) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= topFilter.top + window.scrollY) {
        requestAnimationFrame(this.hide.bind(this));
      }
      this.filterBarScrollTop = scrollTop;
    }
    hide() {
      this.filterBar.classList.add('hide');
      this.filterBar.classList.remove('animate');
    }
    reveal() {
      this.filterBar.classList.add('animate');
      this.filterBar.classList.remove('hide');
    }
  }
  customElements.define('filter-bar', FilterBar);


  (function() {
    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-started-wizard"]) return;
  try {
    
  let args = {
    "wz_nav_style": "progress", // dots, tabs, progress
    "wz_ori": "horizontal",
    "wz_buttons": ".wzd-buttons",
    "wz_button": ".wzd-button",
    "buttons": false,
    "navigation": 'all' // buttons, nav, all
  };

  const wizard = new Wizard(args);
  wizard.init();

  class TotalBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.totalBar = document.getElementById('total-bar');
      this.totalBarBounds = {};
      this.totalBarScrollTop = 0;
      this.onScrollHandlerTotalBar = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandlerTotalBar, false);
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandlerTotalBar);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.totalBarBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.totalBar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= 0) {
        requestAnimationFrame(this.hide.bind(this));
      }
      this.totalBarScrollTop = scrollTop;
    }
    hide() {
      this.totalBar.classList.add('hide');
      this.totalBar.classList.remove('animate');
    }
    reveal() {
      this.totalBar.classList.add('animate');
      this.totalBar.classList.remove('hide');
    }
  }
  customElements.define('total-bar', TotalBar);

  class FilterBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.filterBar = document.getElementById('filter-bar');
      this.filterBarBounds = {};
      this.filterBarScrollTop = 0;
      this.onScrollHandlerFilterBar = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandlerFilterBar, false);
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandlerFilterBar);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.filterBarBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.filterBar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var topFilter = document.getElementById('Wizard_TopFilterDropdown').getBoundingClientRect();
      if (scrollTop > topFilter.top + window.scrollY) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= topFilter.top + window.scrollY) {
        requestAnimationFrame(this.hide.bind(this));
      }
      this.filterBarScrollTop = scrollTop;
    }
    hide() {
      this.filterBar.classList.add('hide');
      this.filterBar.classList.remove('animate');
    }
    reveal() {
      this.filterBar.classList.add('animate');
      this.filterBar.classList.remove('hide');
    }
  }
  customElements.define('filter-bar', FilterBar);


  (function() {
    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  })();

  document.addEventListener('rebuy:smartcart.hide', (event) => {
    window.location = '/';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.getElementById('shopify-section-header');
this.headerBounds = {};
this.currentScrollTop = 0;

this.onScrollHandler = this.onScroll.bind(this);

window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom + 80) {
requestAnimationFrame(this.hide.bind(this));
} else
if (scrollTop < this.currentScrollTop && scrollTop> this.headerBounds.bottom + 80) {
  requestAnimationFrame(this.reveal.bind(this));
  } else
  if (scrollTop <= this.headerBounds.top) { requestAnimationFrame(this.reset.bind(this)); }
    this.currentScrollTop=scrollTop; } 
    hide() {
  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  this.closeMenuDisclosure();

  document.dispatchEvent(new CustomEvent('header:hide'));
}

reveal() {
  this.header.classList.add('shopify-section-header-sticky', 'animate');
  this.header.classList.remove('shopify-section-header-hidden');

  document.dispatchEvent(new CustomEvent('header:show'));
}
    
    reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky' , 'animate' ); }
    closeMenuDisclosure() { this.disclosures=this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure=> disclosure.close());
    }
    }

    customElements.define('sticky-header', StickyHeader);
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      var giftFields = document.getElementsByClassName('gift-field');
      for (var x = 0; x < giftFields.length; x++) {
        giftFields[x].addEventListener('change', debounce((event) => {
          var toElem = document.getElementById('Recipient');
          var fromElem = document.getElementById('Gifter');
          var messageElem = document.getElementById('Custom_Message');
          var toText = toElem ?. value;
          var fromText = fromElem ?. value;
          var messageText = messageElem ?. value;
          if (toText.length < 100 && fromText.length < 100 && messageText.length < 500) {
            toElem.classList.remove('field--with-error');
            fromElem.classList.remove('field--with-error');
            messageElem.classList.remove('field--with-error');
            document.getElementById('recipient-error').innerHTML = "";
            document.getElementById('gifter-error').innerHTML = "";
            document.getElementById('custom-message-error').innerHTML = "";
          } else {
            if (toText.length >= 100) {
              toElem.classList.add('field--with-error');
              document.getElementById('recipient-error').innerHTML = "100 character limit";
            }
            if (fromText.length >= 100) {
              fromElem.classList.add('field--with-error');
              document.getElementById('gifter-error').innerHTML = "100 character limit";
            }
            if (messageText.length >= 500) {
              messageElem.classList.add('field--with-error');
              document.getElementById('custom-message-error').innerHTML = "500 character limit";
            }
          }

          var finalNote = "To: " + toText.substring(0, 99) + ",   From: " + fromText.substring(0, 99) + "   ------    " + messageText.substring(0, 499);
          const body = JSON.stringify({note: finalNote});
          fetch(`${
            routes.cart_update_url
          }`, {
            ...fetchConfig(),
            ...{
              body
            }
          });

        }, 300));
      }
    }
  }

  customElements.define('cart-note', CartNote);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${
        this.openedBy.getAttribute("data-media-id")
      }"])`).forEach((element) => {
        element.classList.remove('active');
      })
      const activeMedia = this.querySelector(`[data-media-id="${
        this.openedBy.getAttribute("data-media-id")
      }"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template') ?. content ?. querySelector('.js-youtube')) 
        activeMedia.loadContent();
      



    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Track anchor link clicks
    const anchorLinks = document.querySelectorAll('.masonry-grid a');

    anchorLinks.forEach((anchor) => {
      anchor.addEventListener('click', function (event) {
        const href = event.currentTarget.getAttribute('href');
        const dataId = event.currentTarget.getAttribute('data-id') || 'no-data-id'; // Handle if data-id is missing

        dataLayer.push({
          event: 'masonryGridClick',
          label: dataId, // Use data-id as the label
        });
      });
    });

    // Track clicks on .modal-open elements inside masonry-grid-container
    const masonryGridContainer = document.querySelector('.masonry-grid-container');

    if (masonryGridContainer) {
      masonryGridContainer.addEventListener('click', function (event) {
        const target = event.target.closest('.modal-open'); // Check if a .modal-open element was clicked
        if (target) {
          const dataId = target.getAttribute('data-id') || 'no-data-id'; // Handle if data-id is missing
          dataLayer.push({
            event: 'masonryGridClick',
            label: dataId, // Use data-id as the label
          });
        }
      });
    }

    const scrollableDiv = document.querySelector('.masonry-grid'); // Change to your div class or ID

    scrollableDiv.addEventListener('scroll', function () {
      const totalScrollWidth = scrollableDiv.scrollWidth - scrollableDiv.clientWidth;
      const currentScroll = scrollableDiv.scrollLeft;
      const scrollPercentage = Math.round((currentScroll / totalScrollWidth) * 100);

      // Push the scroll percentage to the dataLayer when it reaches certain thresholds
      if (scrollPercentage === 25 || scrollPercentage === 50 || scrollPercentage === 75 || scrollPercentage === 100) {
        dataLayer.push({
          event: 'masonryGridScrollDepthPercentage',
          label: scrollPercentage,
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe"]) return;
  try {
    
class TotalBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log('connected callback');
    this.totalBar = document.getElementById('total-bar');
    this.totalBarBounds = {};
    this.testimonials = document.getElementById('testimonials-heading-block');
    this.totalBarScrollTop = 0;
    this.onScrollHandlerTotalBar = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandlerTotalBar, false);
    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandlerTotalBar);
  }

  createObserver() {
    console.log('create observer');
    let observer = new IntersectionObserver((entries, observer) => {
      this.totalBarBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.totalBar);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 0) {
      requestAnimationFrame(this.reveal.bind(this));
    } else
      if (scrollTop <= 0) { requestAnimationFrame(this.hide.bind(this)); } this.totalBarScrollTop=scrollTop; 
  } 
    
  hide() {
    this.totalBar.classList.add('hide'); this.totalBar.classList.remove('animate'); 
  } 
  reveal() {
    this.totalBar.classList.add('animate'); this.totalBar.classList.remove('hide'); 
  } 
} 
customElements.define('total-bar', TotalBar); 
  
  
  } catch(e) { console.error(e); }
})();
})();
